import React from 'react'
import { MdLocalPhone } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { PiNotePencilBold } from "react-icons/pi";
import { Link } from 'react-router-dom';
import './style.css'

import { ImFacebook } from "react-icons/im";

function CustomFooter() {
  return (
    <div className='CustomFooter_main_container'>
      <div className='CustomFooter_contact_links'>
        <ul>
          <li><a href="tel:8218025546"><MdLocalPhone /> +91 821 802 5546</a></li>
          <li><a href="mailto:sales@yatiglobalsolutions.com"><MdOutlineEmail />sales@yatiglobalsolutions.com</a></li>
          <li><Link to={'/contact'}><PiNotePencilBold />Leave your details</Link></li>
        </ul>
      </div>
      <div className='CustomFooter_main_center_footer'>
        <div className='CustomFooter_left_main'>
          <h4>Our Services</h4>
          <li><Link to='/our-services/mobile-app-solutions/mobile-app-development/'>Mobile Solutions</Link></li>
          <li><Link to='/our-services/enterprise-solutions/erp/'>Enterprise Solutions</Link></li>
          <li><Link to='/our-services/digital-marketing/seo/'>Digital Marketing & SEO</Link></li>
          <li><Link to='/our-services/game-development/game-development/'>Game Development</Link></li>
          <li><Link to='/our-services/web-development/full-stack-development-with-next-js/'>Web Development</Link></li>
        </div>
        <div className='CustomFooter_center_main'>
          <h4>YGS Web Solution Office</h4>
          <li><a>11b Raj vihar nawada mathura (281001)</a></li>
          <li><a href='tel:8218025546'>T: 821 802 5546</a></li>
          <li><a href='mailto:sales@yatiglobalsolutions.com'>E: sales@yatiglobalsolutions.com</a></li>
        </div>
        <div className='CustomFooter_right_main'>
          <h4>Let's Connect</h4>
          <div>
            <a href='https://www.facebook.com/p/Yati-Global-Solutions-100063943457620/?locale=eu_ES'><ImFacebook /></a>
          </div>
        </div>
      </div>
      <div className='CustomFooter_partners'>
        <img src='/images/CustomImages/FooterPartners/1.png' />
        <img src='/images/CustomImages/FooterPartners/2.png' />
        <img src='/images/CustomImages/FooterPartners/3.png' />
        <img src='/images/CustomImages/FooterPartners/4.png' />
        <img src='/images/CustomImages/FooterPartners/5.png' />
        <img src='/images/CustomImages/FooterPartners/6.png' />
        <img src='/images/CustomImages/FooterPartners/7.png' />
      </div>
      <div className='CustomFooter_bottom_links'>
        <Link to='/about-us'>Who We Are</Link>
        <Link to='/portfolio'>Our Work</Link>
        <Link to='/contact'>Request a Quote</Link>
        <Link to='/contact'>Contact Us</Link>
      </div>
      <div className='CustomFooter_copyright'>
        ©2025 YGS Web Solutions Pvt. Ltd.
      </div>
    </div>
  )
}

export default CustomFooter